import API from '.';
export default {
    getZoneList: (params) => {
        return API.get('/tasks/routes/zones', {
            params
        });
    },

    getRoute: (params) => {
        return API.get('/tasks/routes/list', {
            params
        });
    },

    getPointTasks: (params) => {
        return API.get('/tasks/routes/point', {
            params
        });
    },

    generate: (params) => {
        return API.post(`/tasks/routes/generate`, params)
    },
}
